import { FC } from 'react';
import { IonFab, IonFabButton } from '@ionic/react';
import { MicrophoneIcon } from '../../theme/Icons';
import { createUseStyles } from 'react-jss';
import { mediaMinWidth } from '../../theme/utils';
import { SIDE_NAV_WIDTH } from '../../navigation/NavConstants';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { RecordingState } from './RecordingState';
import { Recorder } from './Recorder';

export const FAB_WIDTH = 56;

const useStyles = createUseStyles({
    button: {
        marginBottom: 'var(--ion-safe-area-bottom, 0)',

        [mediaMinWidth.lg]: {
            bottom: 0,
            margin: (SIDE_NAV_WIDTH - FAB_WIDTH) / 2
        }
    }
});

export const RecordButton: FC = () => {
    const classes = useStyles();

    const recordingState = useInstance(RecordingState);
    useSubscription(() => recordingState);

    // turn into anPaywallAwareButton (with sparkles?)
    // OR, use the logic in the button to determine if they can record another (5 for free, 6th costs)

    return (
        <IonFab
            vertical="bottom"
            horizontal="center"
            className={classes.button} data-id="record-button"
        >
            <Recorder trackingFrom="Record Nav">
                <IonFabButton
                    id="record-btn"
                    color={recordingState.isRecording() ? 'danger' : 'primary'}
                >
                    <MicrophoneIcon color="light" customSize={28} />
                </IonFabButton>
            </Recorder>
            {/* TODO: drawer */}
        </IonFab>
    );
};
